import React from 'react'
import { Card, CardContent, makeStyles } from '@material-ui/core'
import { COLORES } from '../../../../config/colores'

const useStyles = makeStyles((theme) => ({
  container: {
    color: 'white',
    padding: '12px',
    borderRadius: '8px'
  },
  valores: {
    fontSize: '10rem',
    color: 'white'
  },
  cardHoverEffect: {
    // Estado inicial
    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
    transform: 'scale(1)',
    boxShadow: theme.shadows[2],

    // Estado hover
    '&:hover': {
      transform: 'scale(1.05)',
      boxShadow: theme.shadows[10]
    }
  },
  iconContainer: {
    margin: 0,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      fontSize: '2rem'
    }
  }
}))

function CardValores (props) {
  const { titulo, cantidad, contenido = null, porcentaje = null, icono = null, cardColor = 'white' } = props
  const classes = useStyles()
  // flip card

  const renderPorcentaje = () => {
    return (
      <div style={{ backgroundColor: '#353535', borderRadius: '8px', margin: '2%' }}>
        <div
          style={{
            backgroundColor: COLORES.lightGreen.suave,
            borderRadius: '8px 8px 8px 0',
            width: `${porcentaje + 25}%`
          }}
        > </div>
      </div>
    )
  }

  return (
    <div className={`animation-flipIny ${classes.cardHoverEffect}`}>
      <Card
        className={classes.cardHoverEffect}
        style={{
          height: '100%',
          borderRadius: '18px',
          backgroundColor: cardColor
        }}
      >
        <CardContent style={{ border: '2px solid', borderRadius: '18px', borderColor: 'white', height: '93%', margin: '2%' }}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {icono && <div className={classes.iconContainer}>
              { icono }
            </div>
            }

            <h6
              className={classes.container}
              style={{
                backgroundColor: !cardColor ? COLORES.blue.primary : 'none',
                fontSize: '1.4rem',
                fontWeight: '400',
                marginBottom: 0
              }}>
              {titulo}
            </h6>
          </div>

          <div style={{ color: 'white', padding: '12px', borderRadius: '10px' }}>
            {cantidad &&
              <h1
                className={[classes.container, classes.valores]}
                style={{ fontWeight: 'bold', fontSize: '3rem', marginTop: 0 }}
              >
                {cantidad}
              </h1>

            }

            {porcentaje && renderPorcentaje()}
            { contenido && contenido }

          </div>
        </CardContent>
      </Card>
    </div>
  )
}

export default CardValores
